import * as R from "@effect-ts/core/Collections/Immutable/Dictionary";
export const mapRecord = (d, f) => R.map_(d, f);
export const projectField = t => k => R.map_(t, p => p[k]);
export const projectFieldWithEnv = (t, env) => k => R.map_(t, p => p(env)[k]);
export const projectFieldWithEnv2 = (t, env) => R.map_(t, p => p(env));
export function conjunction(...x) {
  return Object.assign({}, ...x);
}
export const merge = conjunction;
export const collect = (d, f) => // @ts-expect-error
R.collect(f)(d);
export const memo = get => {
  let cache = undefined;
  return () => {
    if (cache === undefined) {
      cache = get();
    }

    return cache;
  };
};
//# sourceMappingURL=index.mjs.map